const USE_MAINNET = true;
const NETWORKS = {
  mainnet:{chainId:'0xCC',chainIdDecimal:204,chainName:'opBNB',rpcUrls:['https://opbnb-mainnet-rpc.bnbchain.org'],blockExplorerUrls:['https://opbnbscan.com'],nativeCurrency:{name:'BNB',symbol:'BNB',decimals:18}},
  testnet:{chainId:'0x15EB',chainIdDecimal:5611,chainName:'opBNB Testnet',rpcUrls:['https://opbnb-testnet-rpc.bnbchain.org'],blockExplorerUrls:['https://testnet.opbnbscan.com'],nativeCurrency:{name:'tBNB',symbol:'tBNB',decimals:18}}
};
const ACTIVE_NETWORK = USE_MAINNET ? NETWORKS.mainnet : NETWORKS.testnet;
export { ACTIVE_NETWORK, USE_MAINNET };
export default ACTIVE_NETWORK;
